import React, { Component } from 'react';
import { push } from 'react-router-redux';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Raven from 'raven-js';
import Button from '@material-ui/core/Button';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Ionicon from 'react-ionicons';
import styles from './styles';

import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

import ReactSelect from 'react-select';

import swal from 'sweetalert2';

// Custom Components
import LoginBlock from '../../components/LoginBlock';

import api from '../../api';

const customStyles = {
  option: (base, state) => {
    let style = {
      ...base,
      '&:active': {
        backgroundColor: 'transparent'
      },
      backgroundColor: 'transparent'
    };

    // if hovering
    if (state.isFocused) {
      style = {
        ...style,
        '&:active': {
          backgroundColor: 'rgba(0,0,0,0.05)'
        },
        backgroundColor: 'rgba(0,0,0,0.05)'
      };
    }

    // if selected
    if (state.isSelected) {
      style = {
        ...style,
        backgroundColor: '#122B4F',
        fontWeight: 'bold'
      };
    }

    return style;
  },
  control: (base, state) => {
    return {
      ...base,
      '&:hover': {
        border: '1px solid #ced4da'
      },
      backgroundColor: 'transparent',
      border: '1px solid #ced4da',
      boxShadow: 'none'
    };
  }
};

class Add extends Component {
  state = {
    checked: false,
    receiptNumber: '',
    receiptTotal: '',
    gstAmount: '',
    totalDonation: 0,

    aidOrganisation: '',
    staffName: '',
    foodCollector: '',

    organisations: [],

    unitTypes: [],
    donations: [
      {
        item: '',
        type: null,
        amount: 0
      }
    ]
  };

  componentDidMount() {
    const { user, loggedIn } = this.props;
    if (loggedIn) {
      this._getMyOrganisations();
      this._getUnitTypes();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { user, loggedIn } = this.props;
    if (!prevProps.loggedIn && loggedIn) {
      this._getMyOrganisations();
      this._getUnitTypes();
    }
  }

  componentDidCatch(error, errorInfo) {
    Raven.captureException(error, { extra: errorInfo });
  }

  _getMyOrganisations = () => {
    api
      .getMyOrganisations()
      .then(data => {
        this.setState({ organisations: data.results });
      })
      .catch(err => {
        console.log(err);
      });
  };

  _getUnitTypes = () => {
    api
      .getUnitTypes()
      .then(data => {
        this.setState({ unitTypes: data });
      })
      .catch(err => {
        console.log(err);
      });
  };

  _handleToggleChecked = () => {
    this.setState({ checked: !this.state.checked });
  };

  _handleChangeReceiptNumber = e => {
    this.setState({ receiptNumber: e.target.value });
  };

  _handleChangeReceiptTotal = e => {
    const { gstAmount } = this.state;
    const total_donation = e.target.value - Number(gstAmount);

    this.setState({
      receiptTotal: e.target.value,
      totalDonation: total_donation
    });
  };

  _handleChangeGstAmount = e => {
    const { receiptTotal } = this.state;
    const total_donation = receiptTotal - Number(e.target.value);

    this.setState({
      gstAmount: e.target.value,
      totalDonation: total_donation
    });
  };

  _handleChangeTotalDonation = e => {
    //this.setState({ totalDonation: e.target.value });
  };

  _handleChangeStaffName = e => {
    this.setState({ staffName: e.target.value });
  };

  _handleChangeFoodCollector = e => {
    this.setState({ foodCollector: e.target.value });
  };

  _handleSelectOrganisation = org => {
    this.setState({ aidOrganisation: org.value });
  };

  _resetForm = () => {
    this.setState({
      checked: false,
      receiptNumber: '',
      receiptTotal: '',
      gstAmount: '',
      totalDonation: ''
    });
  };

  _error = message => {
    swal({
      position: 'center',
      type: 'error',
      title: message
    });
  };

  _handleAddNewRow = () => {
    this.setState({
      donations: [
        ...this.state.donations,
        {
          type: null,
          amount: 0
        }
      ]
    });
  };

  _handleDeleteRow = index => {
    const newDonations = this.state.donations;
    newDonations.splice(index, 1);
    this.setState({
      donations: newDonations
    });
  };

  _handleSelectUnitType = (index, org) => {
    this.setState({
      donations: this.state.donations.map((e, indexOf) => {
        if (indexOf === index) {
          e.type = org.value;
        }
        return e;
      })
    });
  };

  _handleChangeTotalAmount = (index, input) => {
    this.setState({
      donations: this.state.donations.map((e, indexOf) => {
        if (indexOf === index) {
          e.amount = input.target.value;
        }
        return e;
      })
    });
  };

  _handleChangeType = (index, input) => {
    this.setState({
      donations: this.state.donations.map((e, indexOf) => {
        if (indexOf === index) {
          e.item = input.target.value;
        }
        return e;
      })
    });
  };

  _handleSubmitReceipt = () => {
    const {
      receiptNumber,
      receiptTotal,
      gstAmount,
      totalDonation,
      checked,
      aidOrganisation,
      staffName,
      foodCollector
    } = this.state;

    if (!aidOrganisation) {
      return this._error(
        'Please select the aid organisation you are donating to'
      );
    }

    if (!staffName) {
      return this._error(
        'Please insert the name of the staff member who conducted the food donation'
      );
    }

    // if (!foodCollector) {
    //   return this._error(
    //     'Please insert the name of the person collecting the donation on behalf of the aid organisation'
    //   );
    // }

    // if (!receiptNumber) {
    //   return this._error('Please insert your receipt number');
    // }

    // if (!receiptTotal) {
    //   return this._error('Please insert your receipt total');
    // }

    // if (!gstAmount) {
    //   return this._error('Please insert your GST amount');
    // }

    // if (!totalDonation) {
    //   return this._error('Please insert your Total Donation amount');
    // }

    // if (Number(gstAmount) >= Number(receiptTotal)) {
    //   return this._error('GST should be less than the receipt total');
    // }

    // Check user agreed to terms
    if (!checked) {
      return swal({
        position: 'center',
        type: 'error',
        title: 'You must accept the agreement'
      });
    }

    let arrayOfBoobies = [];
    const { donations } = this.state;
    arrayOfBoobies = donations.filter(
      e => e.amount !== null && !!e.amount && e.type !== null
    );

    if (arrayOfBoobies.length === 0) {
      return this._error('No Donation amounts entered');
    }

    let arrayOfUnits = arrayOfBoobies.map(e => {
      var theThang = this.state.unitTypes.find(t => t.tid === e.type);
      return {
        target_id: `${theThang.name} (${theThang.tid})`
      };
    });

    let arrayOfUnitNumbers = arrayOfBoobies.map(e => ({
      value: Number(e.amount)
    }));

    let arrayOfUnitItems = arrayOfBoobies.map(e => ({
      value: e.item
    }));

    let body = {
      type: 'donation',
      field_food_collector_name: { und: [{ value: foodCollector }] },
      field_food_organisation: { und: [Number(aidOrganisation)] },
      field_staff_member_name: { und: [{ value: staffName }] },
      // field_receipt_number: { und: [{ value: receiptNumber }] },
      // field_receipt_total: { und: [{ value: receiptTotal }] },
      // field_gst_amount: { und: [{ value: gstAmount }] },
      // field_total_donation: { und: [{ value: totalDonation }] }
      field_unit: { und: arrayOfUnits },
      field_unit_type: { und: arrayOfUnitItems },
      field_number_of_units: { und: arrayOfUnitNumbers }
    };

    // Submit the timesheet
    api
      .submitReceipt(body)
      .then(result => {
        console.log(JSON.stringify(result, null, 2));
        // console.log(JSON.stringify(result[1], null, 2));
        this._resetForm();
        this.props.changePage('/add/success?id=' + result.nid);

        return swal({
          position: 'center',
          type: 'success',
          title: 'Successfully created your receipt'
        });
      })
      .catch(err => {
        return swal({
          position: 'center',
          type: 'error',
          title: err
        });
      });
  };

  render() {
    const { loggedIn, classes } = this.props;

    const {
      receiptNumber,
      receiptTotal,
      gstAmount,
      totalDonation,
      aidOrganisation,
      staffName,
      foodCollector,
      organisations,
      donations,
      unitTypes
    } = this.state;

    if (!loggedIn) {
      return <LoginBlock />;
    }

    let options = [];

    organisations.map(o => {
      options.push({ value: o.nid, label: o.organisation_name });
    });
    let unitBoos = [];
    unitTypes.map(o => {
      unitBoos.push({ value: o.tid, label: o.name });
    });

    return (
      <Grid container className={classes.root} spacing={0}>
        <Grid item xs={12}>
          <h1 className={classes.title}>New Donation</h1>
        </Grid>

        <Paper className={classes.paper}>
          <div className={classes.inputRow}>
            <div className={classes.inputHalf}>
              <span>Food Relief Farmer</span>
            </div>
            <div className={classes.inputHalf}>
              <ReactSelect
                className="organisation-select"
                defaultValue={''}
                isDisabled={
                  !this.state.organisations ||
                  this.state.organisations.length === 0
                }
                isClearable={false}
                isSearchable={false}
                options={options}
                styles={customStyles}
                onChange={this._handleSelectOrganisation}
              />
            </div>
          </div>

          {/* Staff Name */}
          <div className={classes.inputRow}>
            <div className={classes.inputHalf}>
              <span>Volunteer or Staff Name </span>
            </div>
            <div className={classes.inputHalf}>
              <TextField
                label=""
                id="bootstrap-input"
                value={staffName}
                onChange={this._handleChangeStaffName}
                InputProps={{
                  disableUnderline: true,
                  classes: {
                    root: classes.textFieldRoot,
                    input: classes.textFieldInput
                  }
                }}
                InputLabelProps={{
                  shrink: true,
                  className: classes.textFieldFormLabel
                }}
              />
            </div>
          </div>

          {/* Receipt Number */}
          {/* <div className={classes.inputRow}>
            <div className={classes.inputHalf}>
              <span>Please Enter Receipt Number </span>
            </div>
            <div className={classes.inputHalf}>
              <TextField
                label=""
                id="bootstrap-input"
                value={receiptNumber}
                onChange={this._handleChangeReceiptNumber}
                InputProps={{
                  disableUnderline: true,
                  classes: {
                    root: classes.textFieldRoot,
                    input: classes.textFieldInput
                  }
                }}
                InputLabelProps={{
                  shrink: true,
                  className: classes.textFieldFormLabel
                }}
              />
            </div>
          </div> */}

          {/* Your Amount */}
          <div style={{ height: 16 }} />
          <div className={classes.inputRow}>
            <div className={classes.inputHalf}>
              <span>Donation Received:</span>
            </div>
          </div>
          <div style={{ paddingLeft: 32 }}>
            {donations.map((e, index) => (
              <div>
                {index !== 0 && (
                  <div
                    style={{
                      borderTop: '1px solid #ccc',
                      marginTop: 10
                    }}></div>
                )}

                <div
                  className={classes.inputRow}
                  style={{ position: 'relative' }}>
                  <div
                    onClick={this._handleDeleteRow.bind(null, index)}
                    style={{
                      color: 'red',
                      position: 'absolute',
                      top: 6,
                      left: -32,
                      cursor: 'pointer'
                    }}>
                    <Ionicon
                      icon="md-close"
                      style={{
                        marginRight: 5,
                        marginBottom: 2,
                        color: '#122B4F44'
                      }}
                    />
                  </div>
                  <div className={classes.inputHalf}>
                    <span>Dontation Unit Type</span>
                  </div>
                  <div className={classes.inputHalf}>
                    <ReactSelect
                      className="organisation-select"
                      defaultValue={''}
                      isDisabled={!unitBoos || unitBoos.length === 0}
                      isClearable={false}
                      isSearchable={false}
                      options={unitBoos}
                      styles={customStyles}
                      onChange={this._handleSelectUnitType.bind(null, index)}
                    />
                  </div>
                </div>
                <div className={classes.inputRow}>
                  <div className={classes.inputHalf}>
                    <span>Dontation Amount</span>
                  </div>

                  <div className={classes.inputHalf}>
                    <TextField
                      type="number"
                      value={donations[index].amount}
                      onChange={this._handleChangeTotalAmount.bind(null, index)}
                      label=""
                      id="bootstrap-input"
                      InputProps={{
                        disableUnderline: true,
                        classes: {
                          root: classes.textFieldRoot,
                          input: classes.textFieldInput
                        }
                      }}
                      InputLabelProps={{
                        shrink: true,
                        className: classes.textFieldFormLabel
                      }}
                    />
                  </div>
                </div>
                <div className={classes.inputRow}>
                  <div className={classes.inputHalf}>
                    <span>Donation Item</span>
                  </div>

                  <div className={classes.inputHalf}>
                    <TextField
                      type="text"
                      value={donations[index].name}
                      onChange={this._handleChangeType.bind(null, index)}
                      label=""
                      id="bootstrap-input"
                      InputProps={{
                        disableUnderline: true,
                        classes: {
                          root: classes.textFieldRoot,
                          input: classes.textFieldInput
                        }
                      }}
                      InputLabelProps={{
                        shrink: true,
                        className: classes.textFieldFormLabel
                      }}
                    />
                  </div>
                </div>
              </div>
            ))}
            <div style={{ height: 16 }} />
            <Button
              variant="raised"
              color="primary"
              className={classes.confirmDonationButton}
              onClick={this._handleAddNewRow}>
              + add more
            </Button>
          </div>
          {/* Terms */}
          <div className={classes.termsContainer}>
            <Checkbox
              color="primary"
              checked={this.state.checked}
              tabIndex={-1}
              disableRipple
              onChange={this._handleToggleChecked}
            />

            <p className={classes.termsText}>
              I confirm the donation details entered are true and correct, and
              all these food items are donated to Food For Change.
            </p>
          </div>

          <div className={classes.confirmButtonContainer}>
            <Button
              variant="raised"
              color="primary"
              className={classes.confirmDonationButton}
              onClick={this._handleSubmitReceipt}>
              Confirm
            </Button>
          </div>
        </Paper>
      </Grid>
    );
  }
}

Add = withStyles(styles)(Add);

const mapStateToProps = state => ({
  user: state.user.data,
  loggedIn: state.user.loggedIn
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      changePage: url => push(url)
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Add);



// WEBPACK FOOTER //
// ./src/containers/add/index.js